import { booleanToCallback, createValidatorAllowingFailureMessageOverride } from 'validity'

export default wordCount => createValidatorAllowingFailureMessageOverride(booleanToCallback(val => {
  const words = val.trim().split(' ').length

  return words <= wordCount
}), `This must be ${wordCount} words or less`)
